 
export const small = 768;
export const medium = 1024;
export const large = 1200;
export const xlarge = 1400;
export const xxlarge = 1680;
